
export default function(el) {
    const audio = el.querySelector(".ap__audio");
    const currentTimeEl = el.querySelector(".ap__current-time");
    const sliderEl = el.querySelector(".ap__slider");
    const toggleBtn = el.querySelector(".ap__toggle");
    let isPlaying = false;

    const toggleState = () => isPlaying = !isPlaying;
    
    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        
        return `${minutes}:${returnedSeconds}`;
    }

    const setDuration = () => {
        const durationEl = el.querySelector(".ap__duration");

        if(durationEl)
            durationEl.innerText = calculateTime(audio.duration);

        if(sliderEl)
            sliderEl.max = Math.floor(audio.duration);
    }

    const setCurrentTime = () => {
        if(currentTimeEl)
            currentTimeEl.innerText = calculateTime(audio.currentTime);

        if(sliderEl) {
            sliderEl.value = Math.floor(audio.currentTime);
            el.style.setProperty('--seek-before-width', Math.ceil(sliderEl.value / sliderEl.max * 100) + '%');
        }
    }

    const handlePlayerState = () => el.classList[isPlaying ? "add" : "remove"]("ap--playing");

    const handleToggleBtnClick = () => {
        toggleState();
        handlePlayerState();
        isPlaying ? audio.play() : audio.pause();
    }

    if(!audio) return;
    
    audio.readyState > 0 ? setDuration() : audio.addEventListener('loadedmetadata', setDuration);
    
    audio.addEventListener("ended", () => {
        toggleState();
        handlePlayerState();
    });
    
    if(toggleBtn)
        toggleBtn.addEventListener("click", handleToggleBtnClick);
    
    if(sliderEl) {
        sliderEl.addEventListener('input', (e) => {
            currentTimeEl.textContent = calculateTime(sliderEl.value);
            audio.currentTime = sliderEl.value;
        });
    }

    audio.addEventListener("timeupdate", setCurrentTime);
    setCurrentTime();
}